import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export type DietOptions = "mediterranian" | "vegetarian" | "vegan";
export type OriginOptions = "local" | "national" | "international";

export interface NutritionState {
  diet: DietOptions | null;
  usesEcologicalProducts: boolean;
  originOfProducts: OriginOptions | null;
}

const initialState: NutritionState = {
  diet: null,
  usesEcologicalProducts: false,
  originOfProducts: null,
};

export const nutritionSlice = createSlice({
  name: "nutrition",
  initialState,
  reducers: {
    setDiet(state, action: PayloadAction<DietOptions | null>) {
      state.diet = action.payload;
    },
    setUsesEcologicalProducts(state, action: PayloadAction<boolean>) {
      state.usesEcologicalProducts = action.payload;
    },
    setOriginOfProducts(state, action: PayloadAction<OriginOptions | null>) {
      state.originOfProducts = action.payload;
    },
    setNutritionState(state, action: PayloadAction<NutritionState>) {
      state = action.payload;
    },
  },
});

export const {
  setDiet,
  setUsesEcologicalProducts,
  setOriginOfProducts,
  setNutritionState,
} = nutritionSlice.actions;

export default nutritionSlice.reducer;
